import {
  Gauge,
  Shield,
  Globe,
  ArrowRight,
  Rocket,
  TrendingUp,
} from "lucide-react";
import CanvasPersonalizado from "./internos/CanvasPersonalizado";
import { useLanguage } from "../context/LanguageContext";
import  StructuredData from "./StructuredData";

const Portada = ({ isDarkMode, scrollToSection }) => {
  <StructuredData type="portada" />;
  const { language, translations } = useLanguage();
  const portada = translations[language].portada;
  const features = [
    {
      icon: <Gauge size={40} />,
      title: portada.caracteristicas[0].title,
      description: portada.caracteristicas[0].description,
      color: "from-blue-500 to-cyan-500",
    },
    {
      icon: <Shield size={40} />,
      title: portada.caracteristicas[1].title,
      description: portada.caracteristicas[1].description,
      color: "from-green-500 to-emerald-500",
    },
    {
      icon: <Globe size={40} />,
      title: portada.caracteristicas[2].title,
      description: portada.caracteristicas[2].description,
      color: "from-purple-500 to-pink-500",
    },
  ];

  return (
    <section
      id="inicio"
      className="pt-20 min-h-screen flex items-center pb-[50px] relative overflow-hidden"
    >
      <div className="background-div content--canvas absolute inset-0">
        <CanvasPersonalizado
          baseHue={220}
          backgroundColor={isDarkMode ? "#111827" : "#fdfdfdff"}
        />
      </div>

      <div className="container mx-auto px-4 pt-12 z-[2] pb-0 relative">
        <div className="grid lg:grid-cols-1 gap-12 items-center">
          <div className="space-y-6 animate-fadeIn">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#12A9B0]/10 rounded-full backdrop-blur">
              <Rocket size={18} className="text-[#12A9B0]" />
              <span className="text-sm font-medium text-[#12A9B0]">
                {portada.titulos.solucionesInnovadoras}
              </span>
            </div>
            <h2
              className={`text-5xl lg:text-6xl font-bold leading-tight ${
                isDarkMode ? "text-white" : "text-gray-900"
              }`}
            >
              {portada.titulos.tituloPrincipal}
              <span
                className="text-[#12A9B0] block mt-2"
                style={{ textShadow: "3px 2px 4px #000" }}
              >
                {portada.titulos.metodoHeuristico}
              </span>
            </h2>
            <p className="text-xl leading-relaxed max-w-3xl text-gray-900 dark:text-gray-300">
              {portada.textos.descripcion}
            </p>
            <div className="flex flex-wrap gap-6 py-4">
              <div className="flex items-center gap-2">
                <TrendingUp size={20} className="text-[#12A9B0]" />
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  <strong className="text-[#12A9B0]">
                    {portada.estadisticas.proyectos}
                  </strong>{" "}
                  {portada.textos.proyectosExitosos}
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Shield size={20} className="text-[#12A9B0]" />
                <span className="text-sm text-gray-600 dark:text-gray-400">
                  <strong className="text-[#12A9B0]">
                    {portada.estadisticas.seguridad}
                  </strong>{" "}
                  {portada.textos.seguro}
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection("contacto")}
                className="group px-8 py-4 bg-gradient-to-r from-[#12A9B0] to-[#0e8d92] text-white rounded-lg font-semibold hover:shadow-xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-2"
              >
                {portada.botones.comenzarProyecto}
                <ArrowRight
                  size={20}
                  className="group-hover:translate-x-1 transition-transform"
                />
              </button>
              <button
                onClick={() => scrollToSection("servicios")}
                className="px-8 py-4 border-2 border-[#12A9B0] rounded-lg font-semibold transition-all duration-300 hover:scale-105 animate-pulse text-gray-900 hover:bg-[#12A9B0]/5 dark:text-[#12A9B0] dark:thover:bg-[#12A9B0]/10"
              >
                {portada.botones.verServicios}
              </button>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-8 mt-20">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-xl border-b-2 border-[#12A9B0]/20 transition-all duration-300 hover:transform hover:-translate-y-2 hover:shadow-xl bg-white/90 backdrop-blur dark:bg-gradient-to-b dark:from-gray-800/90 dark:to-gray-900/90 dark:backdrop-blur"
              style={{
                animationDelay: `${index * 0.1}s`,
                animation: "slideUp 0.6s ease-out forwards",
              }}
            >
              <div className="text-[#12A9B0] mb-4 transform group-hover:scale-110 transition-transform ">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-2 text-gray-900 dark:text-white">
                {feature.title}
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                {feature.description}
              </p>

              <div className="mt-4 h-1 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className={`h-full bg-gradient-to-r ${feature.color} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-700`}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portada;
